import { PaintCollectionDisplay } from "@omni/types/components/paintConfigurator/enums/paintCollectionDisplay.enum";
import { RequireChildrenFor } from "@omni/types/components/utils/children.types";
import { cn } from "@omni/utils/styles";

import { ColorListSkeleton } from "@/components/PaintConfigurator/components/colors/components/families/components/colorList/colorList.skeleton";
import { useCollection } from "@/components/PaintConfigurator/context/paintConfigurator.context";
import { useSkeleton } from "@/utils/hooks/useSkeleton.hook";

import { useColorsContext } from "../../context/colors.context";
import { FamiliesContextProvider } from "./context/families.context";

type BaseProps = RequireChildrenFor<{
    className?: string;
}>;

const Base = ({ className, children }: BaseProps) => {
    const { colors, loadingPaintColors } = useColorsContext();
    const { collection } = useCollection();

    const display = collection?.display ?? PaintCollectionDisplay.List;

    const { showSkeleton, showContent, showLoading } =
        useSkeleton(loadingPaintColors);

    return (
        <div
            className={cn(
                {
                    "tw:mt-8": display === "list"
                },
                className
            )}
        >
            {showContent && (
                <FamiliesContextProvider colors={colors}>
                    {children}
                </FamiliesContextProvider>
            )}
            {showSkeleton && <ColorListSkeleton />}
            {showLoading && <div className={cn("tw:h-200")} />}
        </div>
    );
};

export { Base };
